import React from 'react';
import { Link } from 'react-router-dom';
import { PLAY_STORE_URL } from '@/lib/constants';

export function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="py-14 bg-[#FEF7FF] dark:bg-zinc-950 border-t border-[#E7E0EC] dark:border-zinc-800">
      <div className="max-w-[1200px] mx-auto px-8 text-center">
        <div className="text-2xl font-extrabold tracking-[-0.04em] text-[#6750A4] dark:text-m3-dark-primary mb-2.5">
          AwayFX
        </div>
        <p className="text-sm text-[#79747E] mb-6">
          Elegant currency conversion for travellers.
        </p>
        <div className="mb-8 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-5 text-sm font-medium">
          <a
            href="mailto:contact@awayfx.com"
            aria-label="Contact AwayFX by email"
            className="text-[#6750A4] dark:text-m3-dark-primary hover:underline decoration-2 underline-offset-4 transition-colors"
          >
            Contact Us
          </a>
          <span className="hidden sm:block text-[#79747E]/45">&bull;</span>
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#6750A4] dark:text-m3-dark-primary hover:underline decoration-2 underline-offset-4 transition-colors"
          >
            Google Play
          </a>
          <span className="hidden sm:block text-[#79747E]/45">&bull;</span>
          <Link
            to="/privacy"
            className="text-[#6750A4] dark:text-m3-dark-primary hover:underline decoration-2 underline-offset-4 transition-colors"
          >
            Privacy Policy
          </Link>
        </div>
        <div className="text-xs text-[#79747E]/60">
          &copy; {currentYear} Built by Sean Romer &bull; Made in Australia with care.
        </div>
      </div>
    </footer>
  );
}
